(function(){
'use strict';

/* ---------------------------------------------------------- config */
var VIDEO_URL   = 'https://cdn.shopify.com/s/files/1/0802/0426/7717/files/lucerna-hero-scrub.mp4?v=1788949692';
var VIDEO_BYTES = 5611248;              /* real byte size of https://cdn.shopify.com/s/files/1/0802/0426/7717/files/lucerna-hero-scrub.mp4?v=1788949692 */
var POSTER_URL  = 'https://cdn.shopify.com/s/files/1/0802/0426/7717/files/lucerna-hero-poster.jpg?v=1788949692';

var stage   = document.getElementById('stage');
var video   = document.getElementById('hero');
var posterL = document.getElementById('poster');
var ringWrap= document.getElementById('ringwrap');
var ring    = ringWrap ? ringWrap.querySelector('circle') : null;
var heroSec = document.getElementById('hero-sec');
var bandEls = [].slice.call(document.querySelectorAll('.band'));

/* ---------------------------------------------------------- split text once */
function rng(seed){var s=seed>>>0;return function(){s=(s*1664525+1013904223)>>>0;return s/4294967296}}
(function splitAll(){
  var r = rng(20260909);
  document.querySelectorAll('[data-split]').forEach(function(host){
    var words = host.textContent.split(' ');
    host.textContent = '';
    words.forEach(function(w,i){
      var span = document.createElement('span');
      span.className = 'w';
      span.textContent = (i ? ' ' : '') + w;
      span.style.setProperty('--th', (i / Math.max(1, words.length) * 0.42 + r() * 0.05).toFixed(3));
      host.appendChild(span);
    });
  });
})();

/* ---------------------------------------------------------- bands */
var bands = bandEls.map(function(el){
  return {
    el: el,
    a: parseFloat(el.dataset.a),
    b: parseFloat(el.dataset.b),
    ramp: el.dataset.ramp ? parseFloat(el.dataset.ramp) : 0,
    op: -1, k: -1, ks: -1, kb: -1
  };
});
function smoothstep(p,e0,e1){var t=Math.min(1,Math.max(0,(p-e0)/(e1-e0)));return t*t*(3-2*t)}
function clamp(v,lo,hi){return Math.min(hi,Math.max(lo,v))}

var loadK = 0, loadStart = 0;
function updateCaptions(p){
  for (var i=0;i<bands.length;i++){
    var B = bands[i], a = B.a, b = B.b;
    var f = Math.min(0.02,(b-a)/3);
    var op = (i===0 ? 1 : smoothstep(p,a,a+f)) * (i===bands.length-1 ? 1 : (1-smoothstep(p,b-f,b)));
    if (Math.abs(op-B.op) > 0.004){ B.op = op; B.el.style.opacity = op.toFixed(3) }
    var ramp = B.ramp || Math.min(0.025,(b-a)*0.35);
    var k = clamp((p-a)/ramp,0,1);
    if (i===0) k = Math.max(k, loadK);
    if (Math.abs(k-B.k) > 0.008){ B.k = k; B.el.style.setProperty('--k',k.toFixed(3)) }
    if (B.el.classList.contains('settle')){
      var ks = clamp((k-0.55)*2.6,0,1), kb = clamp((k-0.72)*3.4,0,1);
      if (Math.abs(ks-B.ks) > 0.008){ B.ks = ks; B.el.style.setProperty('--ks',ks.toFixed(3)) }
      if (Math.abs(kb-B.kb) > 0.008){ B.kb = kb; B.el.style.setProperty('--kb',kb.toFixed(3)) }
    }
  }
}

/* ---------------------------------------------------------- seek gate */
var seekBusy = false, pendingTime = null;
function requestSeek(t){
  if (!video.duration || isNaN(t)) return;
  if (seekBusy){ pendingTime = t; return }
  seekBusy = true;
  try { video.currentTime = t } catch(e){ seekBusy = false }
}
video.addEventListener('seeked', function(){
  seekBusy = false;
  if (pendingTime !== null){ var t = pendingTime; pendingTime = null; requestSeek(t) }
});
video.addEventListener('error', function(){ seekBusy = false; pendingTime = null; failVideo() });

/* ---------------------------------------------------------- drive loop */
var target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true;
function heroProgress(){
  var r = heroSec.getBoundingClientRect();
  var range = heroSec.offsetHeight - window.innerHeight;
  if (range <= 0) return 0;
  return clamp(-r.top / range, 0, 1);
}
function tick(now){
  var dt = Math.min(100, now - (lastTick || now));
  lastTick = now;
  var k = 0.16;
  shown += (target - shown) * (1 - Math.pow(1 - k, dt / 16.667));
  var settled = Math.abs(target - shown) < 0.0005;
  if (settled){ shown = target; rafId = null; lastTick = 0 }
  else { rafId = requestAnimationFrame(tick) }
  if (video.duration) requestSeek(shown * video.duration);
  updateCaptions(shown);
}
function onScroll(){
  target = heroProgress();
  if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick);
}
if ('IntersectionObserver' in window){
  new IntersectionObserver(function(es){
    heroOnScreen = es[0].isIntersecting;
    if (heroOnScreen && rafId === null && scrubOn) rafId = requestAnimationFrame(tick);
  },{rootMargin:'120px'}).observe(heroSec);
}

/* ---------------------------------------------------------- blob loader */
var heroInited = false;
function initHeroOnce(){
  if (heroInited) return; heroInited = true;
  posterL.style.backgroundImage = "url('" + POSTER_URL + "')";
  var started = false;
  function start(){ if (started) return; started = true; loadHeroBlob().catch(failVideo) }
  var pi = new Image();
  pi.onload = start; pi.onerror = start; pi.src = POSTER_URL;
  setTimeout(start, 4000);
  loadStart = performance.now();
  requestAnimationFrame(function ramp(now){
    loadK = clamp((now - loadStart) / 900, 0, 1);
    updateCaptions(shown);
    if (loadK < 1) requestAnimationFrame(ramp);
  });
}
async function loadHeroBlob(){
  var ctrl = new AbortController();
  var watchdog = setTimeout(function(){ ctrl.abort() }, 20000);
  var res = await fetch(VIDEO_URL, { signal: ctrl.signal });
  if (!res.ok) throw new Error('http ' + res.status);
  var total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
  var reader = res.body.getReader();
  var chunks = [], got = 0, lastRing = 0;
  for(;;){
    var r = await reader.read();
    if (r.done) break;
    clearTimeout(watchdog);
    watchdog = setTimeout(function(){ ctrl.abort() }, 20000);
    chunks.push(r.value); got += r.value.length;
    var frac = Math.min(1, got/total), now = performance.now();
    if (now - lastRing > 100 || frac === 1){
      lastRing = now;
      if (ring) ring.style.setProperty('--ld', Math.round(126 * (1 - frac)));
    }
  }
  clearTimeout(watchdog);
  if (ring) ring.style.setProperty('--ld', 0);
  video.src = URL.createObjectURL(new Blob(chunks));
  video.load();
  video.addEventListener('canplay', function(){
    requestSeek(heroProgress() * video.duration);
    stage.classList.add('video-ready');
    if (ringWrap) ringWrap.style.display = 'none';
  }, { once:true });
}
function failVideo(){
  if (ringWrap && !ringWrap.dataset.failed){
    ringWrap.dataset.failed = '1';
    ringWrap.innerHTML = '<svg class="chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 9l6 6 6-6"/></svg>';
  }
  stage.classList.add('video-failed');
}

/* ---------------------------------------------------------- static hero gate */
var GATES = [
  '(max-width: 720px)',
  '(orientation: portrait) and (max-width: 1024px)',
  '(orientation: portrait) and (pointer: coarse)',
  '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
  '(prefers-reduced-motion: reduce)'
];
var scrubOn = false;
function enableScrub(){
  if (scrubOn) return; scrubOn = true;
  initHeroOnce();
  window.addEventListener('scroll', onScroll, {passive:true});
  bands.forEach(function(b){ b.op=-1;b.k=-1;b.ks=-1;b.kb=-1 });
  unpinFinalStates();
  updateCaptions(heroProgress());
  onScroll();
}
function disableScrub(){
  if (!scrubOn) return; scrubOn = false;
  window.removeEventListener('scroll', onScroll);
  if (rafId !== null){ cancelAnimationFrame(rafId); rafId = null }
}
function applyHeroMode(){
  if (GATES.some(function(q){ return matchMedia(q).matches })) disableScrub();
  else enableScrub();
}
var MQLS = GATES.map(function(q){ return matchMedia(q) });
MQLS.forEach(function(m){ m.addEventListener('change', applyHeroMode) });

/* ---------------------------------------------------------- reduced motion, both directions */
function pinToFinalStates(){
  document.querySelectorAll('.rev,.stagger').forEach(function(e){ e.classList.add('in','done') });
  var sp = document.getElementById('spinePath'), sg = document.getElementById('spineGlow');
  if (sp){ sp.style.setProperty('--draw',1); sg.style.setProperty('--draw',1) }
  var dim = document.getElementById('dim');
  if (dim){ dim.classList.add('done'); dim.style.setProperty('--warm',1); warm = 1; setDimCap(1) }
}
function unpinFinalStates(){
  var sp = document.getElementById('spinePath'), sg = document.getElementById('spineGlow');
  if (sp){ sp.style.removeProperty('--draw'); sg.style.removeProperty('--draw') }
  drawSpine();
}
matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function(e){
  if (e.matches) pinToFinalStates(); else applyHeroMode();
});

/* ---------------------------------------------------------- nav */
var nav = document.getElementById('nav');
var navLast = null, navLit = null;
window.addEventListener('scroll', function(){
  var s = window.scrollY > 60;
  if (s !== navLast){ navLast = s; nav.classList.toggle('solid', s) }
  /* the bar turns cream the moment the hero clears it, so it never sits dark on dark ink */
  var l = heroSec.getBoundingClientRect().bottom <= 74;
  if (l !== navLit){ navLit = l; nav.classList.toggle('lit', l) }
}, {passive:true});

/* ---------------------------------------------------------- entrances */
if ('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(en){
      if (!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('in');
      io.unobserve(el);
      if (el.classList.contains('stagger')) setTimeout(function(){ el.classList.add('done') }, 1100);
    });
  },{rootMargin:'0px 0px -12% 0px'});
  document.querySelectorAll('.rev,.stagger').forEach(function(e){ io.observe(e) });
}

/* ---------------------------------------------------------- the spine (signature) */
var spinePath = document.getElementById('spinePath');
var spineGlow = document.getElementById('spineGlow');
var lastDraw = -1;
function drawSpine(){
  if (!spinePath) return;
  var m = document.getElementById('main');
  var r = m.getBoundingClientRect();
  var range = r.height - window.innerHeight;
  var p = range > 0 ? clamp(-r.top / range, 0, 1) : 0;
  if (Math.abs(p - lastDraw) < 0.004) return;
  lastDraw = p;
  spinePath.style.setProperty('--draw', p.toFixed(3));
  spineGlow.style.setProperty('--draw', p.toFixed(3));
}
window.addEventListener('scroll', drawSpine, {passive:true});

/* ---------------------------------------------------------- motes */
(function(){
  var box = document.getElementById('motes');
  if (!box) return;
  var r = rng(77);
  for (var i=0;i<16;i++){
    var d = document.createElement('span');
    d.className = 'mote';
    d.style.left = (r()*100).toFixed(2) + '%';
    d.style.bottom = '-4vh';
    var dur = 26 + r()*30;
    d.style.animationDuration = dur.toFixed(1) + 's';
    d.style.animationDelay = '-' + (r()*dur).toFixed(1) + 's';
    d.style.opacity = (0.25 + r()*0.4).toFixed(2);
    box.appendChild(d);
  }
})();

/* ---------------------------------------------------------- the hold moment */
var warm = 0, holding = false, holdRaf = null, holdLast = 0;
var dim = document.getElementById('dim');
var dimStage = document.getElementById('dimstage');
var dimCap = document.getElementById('dimcap');
var holdBtn = document.getElementById('holdbtn');
var capLast = '';
function setDimCap(w){
  var t = w > 0.92 ? 'Warm lamplight' : (w > 0.35 ? 'Warming' : 'Cold screen light');
  if (t !== capLast){ capLast = t; if (dimCap) dimCap.textContent = t }
}
var warmLatched = false;
function holdTick(now){
  var dt = Math.min(100, now - (holdLast || now)); holdLast = now;
  var step = dt / 1000;
  if (!warmLatched) warm = clamp(warm + (holding ? step / 1.5 : -step / 1.1), 0, 1);
  if (dim){ dim.style.setProperty('--warm', warm.toFixed(3)) }
  setDimCap(warm);
  if (warm >= 1 && dim){ warmLatched = true; dim.classList.add('done') }  /* completing it keeps the room warm */
  if (!warmLatched && ((holding && warm < 1) || (!holding && warm > 0))) holdRaf = requestAnimationFrame(holdTick);
  else { holdRaf = null; holdLast = 0 }
}
function startHold(e){
  if (e && e.cancelable) e.preventDefault();
  holding = true;
  if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick);
}
function endHold(){ holding = false; if (holdRaf === null) holdRaf = requestAnimationFrame(holdTick) }
if (holdBtn){
  holdBtn.addEventListener('mousedown', startHold);
  holdBtn.addEventListener('touchstart', startHold, {passive:false});
  ['mouseup','mouseleave','touchend','touchcancel','blur'].forEach(function(ev){
    holdBtn.addEventListener(ev, endHold);
  });
  holdBtn.addEventListener('keydown', function(e){ if (e.key===' '||e.key==='Enter'){ e.preventDefault(); startHold() } });
  holdBtn.addEventListener('keyup', function(e){ if (e.key===' '||e.key==='Enter'){ endHold() } });
}

/* ---------------------------------------------------------- faq */
document.querySelectorAll('.q button').forEach(function(b){
  b.addEventListener('click', function(){
    var q = b.parentElement, open = q.classList.toggle('open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
});

/* ---------------------------------------------------------- pause when hidden */
document.addEventListener('visibilitychange', function(){
  document.body.classList.toggle('paused', document.hidden);
});

/* ---------------------------------------------------------- go */
if (matchMedia('(prefers-reduced-motion: reduce)').matches) pinToFinalStates();
applyHeroMode();
drawSpine();
})();
